import _toConsumableArray from "/codebuild/output/src856819620/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
export default function removeClasses() {
  var _el$classList;
  var swiper = this;
  var el = swiper.el,
    classNames = swiper.classNames;
  (_el$classList = el.classList).remove.apply(_el$classList, _toConsumableArray(classNames));
  swiper.emitContainerClasses();
}